// @ts-nocheck
import { HasCartContext, withCart } from "@insite/client-framework/Components/CartContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import * as React from "react";

type Props = WidgetProps & HasCartContext;

export interface SavedOrderDetailsWarningMessageStyles {
    savedOrderDetailsWarningMessageInfosBox?: InfosBoxProps;
}

export const savedOrderDetailsMessageStyles: SavedOrderDetailsWarningMessageStyles = {
    savedOrderDetailsWarningMessageInfosBox: { type: "warning" },
};

const SavedOrderDetailsWarningMessage: React.FunctionComponent<Props> = ({ cart }) => {
    const [canAddAllToCart, setCanAddAllToCart] = React.useState(false);
    const [isCartLoaded, setIsCartLoaded] = React.useState(false);

    React.useEffect(() => {
        if (!cart || !cart.cartLines) {
            setIsCartLoaded(false);
            return;
        }

        const newCanAddAllToCart = cart.cartLines?.every(line => line.canAddToCart) ?? false;
        setCanAddAllToCart(newCanAddAllToCart);
        setIsCartLoaded(true);
    }, [cart]);

    if (!isCartLoaded || canAddAllToCart) {
        return null;
    }

    return (
        <InfosBox {...savedOrderDetailsMessageStyles.savedOrderDetailsWarningMessageInfosBox}>
            {translate("Saved Order Details Warning Message")}
        </InfosBox>
    );
};

const widgetModule: WidgetModule = {
    component: withCart(SavedOrderDetailsWarningMessage),
    definition: {
        group: "Saved Order Details",
        displayName: "Saved Order Details Warning Message",
        allowedContexts: ["SavedOrderDetailsPage"],
    },
};

export default widgetModule;
